import { render, staticRenderFns } from "./CoachesTableOverview.vue?vue&type=template&id=6f3a6c10&scoped=true&"
import script from "./CoachesTableOverview.vue?vue&type=script&lang=js&"
export * from "./CoachesTableOverview.vue?vue&type=script&lang=js&"
import style0 from "./CoachesTableOverview.vue?vue&type=style&index=0&id=6f3a6c10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a6c10",
  null
  
)

export default component.exports